require('./cmWalletBuyStep2.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

// @ components
const CmLegalDisclaimer = require('wealth-cm/components/cmLegalDisclaimer/cmLegalDisclaimer');
const CmFundsSummary = require('wealth-cm/components/cmFundsSummary/cmFundsSummary');
const {
    OKConsents,
} = require('gdpr-consents/components/OKConsents/OKConsents.js');
const CmTransferOriginContractsSummaryStep2 = require('../../cmTransferOriginContractsSummaryStep2/cmTransferOriginContractsSummaryStep2');
const { OKMessage } = require('commonsComponents/OKMessage');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const {
    getTranslationIntervenerFromType,
} = require('wealth-cm/utilities/intervenerNameHelper');
const { recordProcess, PROC_BUY_GDI, PROC_STEP } = require('utilities/tagging');

const {
    CM_WIZARD_FIRST_STEP,
    CM_WIZARD_SECOND_STEP,
    CM_GDPR_PID,
    CM_BUY_TYPE_MONEY,
    CM_EUR_CURRENCY_SYMBOL,
} = require('../../../constants/constants');

class CmWalletBuyStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleDisclaimerChange = this.handleDisclaimerChange.bind(this);
    }

    componentDidMount() {
        const { immCmWalletBuy } = this.props;
        const eventTag = immCmWalletBuy.get('eventTag');
        recordProcess(PROC_BUY_GDI, PROC_STEP + 2, { processDetail: eventTag });
    }

    handleDisclaimerChange(ev) {
        this.props.changeDisclaimerCheck(ev.target.checked);
    }

    buildIntervenersInfo(interveners) {
        const intervenersBlock = interveners.map((intervener, index) => (
            <div
                key={index}
                className="cm-wallet-buy-step2__info-item col-lg-12 col-sm-12 col-xs-12"
            >
                <span className="cm-wallet-buy-step2__info-title">
                    {intervener.get('name')}
                </span>
                <span className="cm-wallet-buy-step2__info-body">
                    {getTranslationIntervenerFromType(intervener.get('type'))}
                </span>
            </div>
        ));

        return intervenersBlock;
    }

    buildHeader() {
        return (
            <div className="cm-wallet-buy-step2__header">
                <h2 className="cm-wallet-buy-step2__title">
                    <FormattedText value="brokerCM-walletBuyStep2PurchaseSummary" />
                </h2>
                <p className="cm-wallet-buy-step2__description">
                    <FormattedText value="brokerCM-walletBuyStep2VerificationData" />
                </p>
            </div>
        );
    }

    buildFundsDetails(portfolio) {
        const { immCmWalletBuy, reportCompleted } = this.props;
        const liquidityTransfer =
            immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY;
        const originFundMatchedInPortfolio = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'originFundMatchedInPortfolio',
        ]);
        let fundsToBuyLeyend;
        let fundMatchedInCmPortfolioText;
        let originFundMatchedIsin;
        const allDocumentsReadsDirty = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_SECOND_STEP,
            'errorFlags',
            'disclaimer',
        ]);

        if (!liquidityTransfer && !originFundMatchedInPortfolio) {
            fundsToBuyLeyend = (
                <div className="cm-wallet-buy-step2__funds-to-buy-leyend">
                    <OKMessage type="informative" modifier="dark-bg">
                        <FormattedText value="brokerCM-brokerCM_buyStep2FundsToBuyLeyend" />
                    </OKMessage>
                </div>
            );
        }

        if (originFundMatchedInPortfolio) {
            originFundMatchedIsin = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_FIRST_STEP,
                'originFundMatchedIsin',
            ]);
            fundMatchedInCmPortfolioText = (
                <div className="cm-wallet-buy-step2__fund-matched-portfolio-leyend">
                    <OKMessage type="informative" modifier="light">
                        <div>
                            <FormattedText value="brokerCM-brokerCM_buyStep2MatchesCmPortfolioMayorValueText1" />
                        </div>
                        <div>
                            <FormattedText value="brokerCM-brokerCM_buyStep2MatchesCmPortfolioMayorValueText2" />
                        </div>
                    </OKMessage>
                </div>
            );
        }

        return (
            <div>
                <div className="cm-wallet-buy-step2__funds-details-box">
                    <div className="cm-wallet-buy-step2__subtitle">
                        <FormattedText value="brokerCM-buyStep1WalletFundsDetails" />
                    </div>
                    {allDocumentsReadsDirty && (
                        <div className="cm-buy-step1__warning-documents">
                            <OKMessage type="warning">
                                <FormattedText value="brokerLegalDocumentation-documentsRead" />
                            </OKMessage>
                        </div>
                    )}
                    <div className="cm-wallet-buy-step2__funds-summary-wrapper">
                        <CmFundsSummary
                            portfolio={portfolio}
                            onLegalDocumentClick={
                                this.props.onLegalDocumentClick
                            }
                            originFundMatchedIsin={originFundMatchedIsin}
                            reportCompleted={reportCompleted}
                            isFundsLink={false}
                        />
                    </div>
                    {fundMatchedInCmPortfolioText}
                </div>
                {fundsToBuyLeyend}
            </div>
        );
    }

    buildFamilyAccountInfo(familyCCInfoTitle, familyAccount) {
        return (
            <div className="cm-wallet-buy-step2__info-item col-sm-12 col-xs-12">
                <span className="cm-wallet-buy-step2__info-title">
                    {familyCCInfoTitle}
                </span>
                <span className="cm-wallet-buy-step2__info-body">
                    {getLastNChars(familyAccount)}
                </span>
            </div>
        );
    }

    buildContractInfo(amountTitle, amount) {
        const amountBlock = amount.get('amount') + ' ' + CM_EUR_CURRENCY_SYMBOL;

        return (
            <div className="cm-wallet-buy-step2__info-item col-sm-12 col-xs-12">
                <span className="cm-wallet-buy-step2__info-title">
                    {amountTitle}
                </span>
                <span className="cm-wallet-buy-step2__info-body">
                    {amountBlock}
                </span>
            </div>
        );
    }

    buildAccountInfo(step1Info, familyAccount, alias) {
        const { immCmWalletBuy, immAccounts } = this.props;
        const amount = step1Info.get('accountAmount');
        const interveners = step1Info.get('interveners');
        const amountTitle = formatText(
            'brokerCM-transferOriginContractsSummaryBalanceLeftHeader',
        );
        const familyCCInfoBlock = this.buildFamilyAccountInfo(
            alias,
            familyAccount,
        );
        const contractInfoBlock = this.buildContractInfo(amountTitle, amount);
        const intervenersInfoBlock = this.buildIntervenersInfo(interveners);
        const originFundMatchedInPortfolio = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'originFundMatchedInPortfolio',
        ]);
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);
        const subtitle = isTransferWithMoney
            ? 'brokerCM_walletBuyStep2TraspassLiquiditySubtitle'
            : 'walletBuyStep2TraspassInfoSubtitle';

        if (immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY) {
            return (
                <div className="cm-wallet-buy-step2__info-box">
                    <h2 className="cm-wallet-buy-step2__subtitle cm-wallet-buy-step2__info-box--subtitle">
                        <FormattedText value="brokerCM-walletBuyStep2AssociatedCC" />
                    </h2>
                    <div className="cm-wallet-buy-step2__info-content row">
                        <div className="col-lg-3 col-sm-4 col-xs-12">
                            {familyCCInfoBlock}
                            {contractInfoBlock}
                        </div>
                        <div className="col-lg-9 col-sm-8 col-xs-12">
                            {intervenersInfoBlock}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="cm-wallet-buy-step2__info-box">
                    <h2 className="cm-wallet-buy-step2__subtitle cm-wallet-buy-step2__info-box--subtitle">
                        <FormattedText value={`brokerCM-${subtitle}`} />
                    </h2>
                    <CmTransferOriginContractsSummaryStep2
                        immCmWalletBuy={immCmWalletBuy}
                        immAccounts={immAccounts}
                        originFundMatchedInPortfolio={
                            originFundMatchedInPortfolio
                        }
                    />
                </div>
            );
        }
    }

    render() {
        const { immCmWalletBuy, immAccounts } = this.props;
        const step1Info = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
        const portfolio = immCmWalletBuy.getIn(['portfolios', 0]);
        const familyAccount = immAccounts.getIn([
            'byId',
            step1Info.get('accountNumber'),
            'contractNumber',
        ]);
        const accountAlias = immAccounts.getIn([
            'byId',
            step1Info.get('accountNumber'),
            'alias',
        ]);
        const headerBlock = this.buildHeader();
        const fundsDetailsBlock = this.buildFundsDetails(portfolio);
        const accountInfoBlock = this.buildAccountInfo(
            step1Info,
            familyAccount,
            accountAlias,
        );

        return (
            <div className="cm-wallet-buy-step2">
                <header className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12">
                        {headerBlock}
                    </div>
                </header>
                <div>
                    <section className="cm-wallet-buy-step2__main-section">
                        <div className="cm-wallet-buy-step2__center-panel row">
                            <div className="col-lg-12">{accountInfoBlock}</div>
                        </div>
                        <div className="cm-wallet-buy-step2__center-panel row">
                            <div className="col-lg-12">{fundsDetailsBlock}</div>
                        </div>
                    </section>
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-xs-12">
                            <OKConsents placementId={CM_GDPR_PID} />
                        </div>
                        <div className="col-lg-12 col-md-12 col-xs-12">
                            <div className="cm-wallet-buy-step2__legal-disclaimer-wrapper">
                                <CmLegalDisclaimer
                                    checked={immCmWalletBuy.getIn([
                                        'steps',
                                        CM_WIZARD_SECOND_STEP,
                                        'isDisclaimerChecked',
                                    ])}
                                    onChange={this.handleDisclaimerChange}
                                    errorState={immCmWalletBuy.getIn([
                                        'steps',
                                        CM_WIZARD_SECOND_STEP,
                                        'errorFlags',
                                        'disclaimer',
                                    ])}
                                />
                            </div>
                        </div>
                    </div>
                    <hr className="cm-wallet-buy-step2__separation-line" />
                </div>
            </div>
        );
    }
}

CmWalletBuyStep2.propTypes = {
    immCmWalletBuy: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    changeDisclaimerCheck: PropTypes.func.isRequired,
    onLegalDocumentClick: PropTypes.func.isRequired,
    reportCompleted: PropTypes.func.isRequired,
};

module.exports = CmWalletBuyStep2;
